// list is from http://support.clearbit.com/article/120-employment-role-and-seniority
// and is snake to title case converted
export const CEO = 'CEO';
export const COMMUNICATIONS = 'Communications';
export const CONSULTING = 'Consulting';
export const CUSTOMER_SERVICE = 'Customer Service';
export const EDUCATION = 'Education';
export const ENGINEERING = 'Engineering';
export const EXECUTIVE = 'Executive';
export const FINANCE = 'Finance';
export const FOUNDER = 'Founder';
export const HEALTH_PROFESSIONAL = 'Health Professional';
export const HUMAN_RESOURCES = 'Human Resources';
export const INFORMATION_TECHNOLOGY = 'Information Technology';
export const LEGAL = 'Legal';
export const MARKETING = 'Marketing';
export const OPERATIONS = 'Operations';
export const OWNER = 'Owner';
export const PRESIDENT = 'President';
export const PRODUCT = 'Product';
export const PUBLIC_RELATIONS = 'Public Relations';
export const REAL_ESTATE = 'Real Estate';
export const RECRUITING = 'Recruiting';
export const RESEARCH = 'Research';
export const SALES = 'Sales';
export const OTHER = 'Other';

export const ALL = [
  CEO,
  COMMUNICATIONS,
  CONSULTING,
  CUSTOMER_SERVICE,
  EDUCATION,
  ENGINEERING,
  EXECUTIVE,
  FINANCE,
  FOUNDER,
  HEALTH_PROFESSIONAL,
  HUMAN_RESOURCES,
  INFORMATION_TECHNOLOGY,
  LEGAL,
  MARKETING,
  OPERATIONS,
  OWNER,
  PRESIDENT,
  PRODUCT,
  PUBLIC_RELATIONS,
  REAL_ESTATE,
  RECRUITING,
  RESEARCH,
  SALES,
  OTHER,
];

// new onboarding survey roles not tied 1:1 to clearbit
export const SUPPORT = 'Support';
export const DESIGN = 'Design';
export const CUSTOMER_SUCCESS = 'Customer Success';

export const ONBOARDING_JOB_ROLES = [
  EXECUTIVE,
  SALES,
  PRODUCT,
  SUPPORT,
  MARKETING,
  DESIGN,
  OPERATIONS,
  ENGINEERING,
  CUSTOMER_SUCCESS,
];

export const MANAGEMENT_LEVEL_IC = 'Individual Contributor';
export const MANAGEMENT_LEVEL_MANAGER = 'Manager';
export const MANAGEMENT_LEVEL_EXECUTIVE = 'Executive';

export const ONBOARDING_MANAGEMENT_LEVELS = [
  MANAGEMENT_LEVEL_IC,
  MANAGEMENT_LEVEL_MANAGER,
  MANAGEMENT_LEVEL_EXECUTIVE,
];

export const ONBOARDING_JOB_ROLES_WITH_MESSAGE = [
  {
    role: SALES,
    message: 'Sales teams use Loom for personal outreach videos.',
  },
  {
    role: DESIGN,
    message: 'Designers use Loom to walk through designs.',
  },
  {
    role: PRODUCT,
    message: 'Product teams use Loom to provide context.',
  },
  {
    role: ENGINEERING,
    message: 'Engineers use Loom to demo new features.',
  },
  {
    role: MARKETING,
    message: 'Marketing teams use Loom to promote new features.',
  },
  {
    role: OPERATIONS,
    message: 'Operations teams use Loom to provide feedback.',
  },
  {
    role: SUPPORT,
    message: 'Support teams use Loom to record how-to videos.',
  },
  {
    role: CUSTOMER_SUCCESS,
    message: 'Customer Success teams use Loom to onboard new customers.',
  },
  {
    role: EXECUTIVE,
    message: 'Executives use Loom to send out company updates.',
  },
  {
    role: OTHER,
    message: 'People use Loom to share ideas and provide context.',
  },
];
